export default {
  data() {
    return {
      //企业地址信息
      ADDRESS_SCHEMA: {
        area: {
          label: '地区',
          disabled: true,
          slotName: 'area',
        },
        registerAddress: {
          label: '注册地址',
          type: 'input',
          disabled: true,
        },
        postcode: {
          label: '邮编',
          type: 'input',
          disabled: true,
        },
        mobile: {
          label: '联系电话',
          type: 'input',
          disabled: true,
        },
        fax: {
          label: '传真',
          type: 'input',
          disabled: true,
        },
        email: {
          label: '电子邮箱',
          type: 'input',
          disabled: true,
        },
        officialAddress: {
          label: '官网地址',
          type: 'input',
          disabled: true,
        },
      },
      labelCol: {
        xs: { span: 9 },
      },
      wrapperCol: {
        xs: { span: 14 },
      },
      //企业基本信息-数据
      sourceDataBasic: {
        code: '',
        area: [],
        // country:'',
        // province:'',
        // city:'',
        registerAddress: '',
        postcode: '',
        mobile: '',
        fax: '',
        email: '',
        officialAddress: '',
      },
    }
  },
}
